module.exports = __webpack_public_path__ + "img/group_bai.320acfb6.png";